import { ITank, IRack } from "@/types/data";
import { Dispatch } from "react";
import DropdownSelect from "../DropdownSelect";
import { Box } from "@chakra-ui/react";

interface TankAndRackSelectorProps {
  tankData: {
    tankId?: string;
    setTankId?: Dispatch<React.SetStateAction<string>>;
    tanks?: ITank[];
    tanksLoading?: boolean;
  };
  rackData: {
    rackId?: string;
    setRackId?: Dispatch<React.SetStateAction<string>>;
    racks?: IRack[];
    racksLoading?: boolean;
  };
}

function TankAndRackSelector({
  tankData,
  rackData,
}: TankAndRackSelectorProps) {
  const { tankId, setTankId, tanks, tanksLoading } = tankData;
  const { rackId, setRackId, racks, racksLoading } = rackData;

  return (
    <Box flexBasis="100%" mb="2">
      {!tankId && (
        <DropdownSelect
          label="Tank"
          collection={tanks?.map((tank) => ({ label: tank.name, value: tank.id.toString() })) || []}
          value={tankId}
          onValueChange={(value) => setTankId && setTankId(value)}
          isLoading={tanksLoading ?? false}
          placeholder="Select Tank"
        />
      )}
      {tankId && !rackId && (
        <DropdownSelect
          label="Rack"
          collection={racks?.map((rack) => ({ label: rack.name, value: rack.id.toString() })) || []}
          value={rackId}
          onValueChange={(value) => setRackId && setRackId(value)}
          isLoading={racksLoading ?? false}
          placeholder="Select Rack"
        />
      )}
    </Box>
  );
}

export default TankAndRackSelector;
